import { ref } from 'vue';
import { getCustomerDetail, getPurchaserByNameCodeCommon } from '@/api/production-demand';
import {
  IPurchaserDetailBaseInfo,
  IPurchaserDetailContactsItem,
  IPurchaserListListItem,
} from '@/api/production-demand/type';

const fuzzyCustomerList = ref<IPurchaserListListItem[]>([]);
// 请求客户信息
export function useFuzzyCustomerByNameCode() {
  // const fuzzyCustomerList = ref<ISearchPurchaserPrivateChooseResListItem[]>([]);
  const fuzzyCustomerLoading = ref(false);

  const fuzzyCustomerRemoteMethod = async (keyword: string) => {
    keyword = keyword.trim();
    try {
      if (!keyword) {
        fuzzyCustomerList.value = [];
        return;
      }
      fuzzyCustomerLoading.value = true;
      const { data } = await getPurchaserByNameCodeCommon({
        keyword,
        followState: '1',
        includeOld: true,
      });
      fuzzyCustomerList.value = data?.list ?? [];
    } catch (error) {
      if (error && (error as any).isCancel) {
        setTimeout(() => {
          fuzzyCustomerLoading.value = true;
        });
      }
    } finally {
      fuzzyCustomerLoading.value = false;
    }
  };

  return {
    fuzzyCustomerLoading,
    fuzzyCustomerList,
    fuzzyCustomerRemoteMethod,
  };
}

// 请求客户信息详情
export function useFuzzyCustomerDetail() {
  const contactsList = ref<IPurchaserDetailContactsItem[]>([]);
  const baseInfo = ref({} as IPurchaserDetailBaseInfo);
  const fetchCustomerDetailLoading = ref(false);

  const fetchCustomerDetailById = async (id: string) => {
    try {
      if (!id) {
        contactsList.value = [];
        baseInfo.value = {} as IPurchaserDetailBaseInfo;
        return;
      }
      fetchCustomerDetailLoading.value = true;
      const { data } = await getCustomerDetail(id);
      baseInfo.value = data?.baseInfo;
      contactsList.value = data.contacts;
    } catch (error: any) {
      console.error(error);
      if (error && (error as any).isCancel) {
        setTimeout(() => {
          fetchCustomerDetailLoading.value = true;
        });
      }
    } finally {
      fetchCustomerDetailLoading.value = false;
    }
  };
  return {
    baseInfo,
    contactsList,
    fetchCustomerDetailLoading,
    fetchCustomerDetailById,
  };
}
